import { AffiliateApi } from "@/api/affiliates";
import { CreateAffiliateUserRequest } from "@/api/affiliates/types";
import { ResourceName } from "@/utils";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useNotify } from "react-admin";
import { useUIStore } from "@/stores";

export const useCreateAffiliateUser = () => {
  const queryClient = useQueryClient();
  const notify = useNotify();
  const { closeModal } = useUIStore();

  const { mutate: createAffiliateUser, isPending } = useMutation({
    mutationFn: (body: CreateAffiliateUserRequest) =>
      AffiliateApi.createAffiliateUser(body),
    onError: (error) => {
      setTimeout(() => {
        notify(error, { type: "error" });
      }, 250);
    },
    onSuccess: () => {
      closeModal();
      queryClient.invalidateQueries({
        queryKey: [ResourceName.AFFILIATE_USERS],
      });
      setTimeout(() => {
        notify("User is created!", { type: "success" });
      }, 250);
    },
  });

  return {
    createAffiliateUser,
    createAffiliateUserLoading: isPending,
  };
};
